import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../config/api';
import { DashboardConfig, DeviceListItem, DeviceKeyItem, ChartSeries } from '../types/dashboard';

export const getDeviceList = (): Promise<DeviceListItem[]> =>
  axiosInstance.get(API_ENDPOINTS.getDeviceList).then(r => {
    const raw = r.data?.data ?? r.data;
    const list = Array.isArray(raw) ? raw : [];
    return list.map((d: any) => ({ id: d.id, name: d.deviceName ?? d.name }));
  });

export const getDashboardByName = (name: string): Promise<DashboardConfig | null> =>
  axiosInstance.get(API_ENDPOINTS.getDashboardByName(name)).then(r => r.data?.data ?? r.data).catch(() => null);

export const createDashboard = (payload: { name: string; configJson: string }): Promise<DashboardConfig> =>
  axiosInstance.post(API_ENDPOINTS.createDashboard, payload).then(r => r.data?.data ?? r.data);

export const updateDashboard = (payload: { id: number; name: string; configJson: string }): Promise<void> =>
  axiosInstance.put(API_ENDPOINTS.updateDashboard, payload).then(() => undefined);

export const getDeviceKeys = (deviceId: number): Promise<DeviceKeyItem[]> =>
  axiosInstance.get(API_ENDPOINTS.getDeviceKeys(deviceId)).then(r => {
    const raw = r.data?.data ?? r.data;
    const list = Array.isArray(raw) ? raw : [];
    return list.map((item: any) => ({ id: item.id, name: item.name }));
  });

export const getChartData = (
  deviceId: number,
  keyIds: number[],
  from: string,
  to: string,
): Promise<ChartSeries[]> =>
  axiosInstance
    .get(API_ENDPOINTS.getChartData(deviceId, keyIds, from, to))
    .then(r => r.data?.data?.series ?? r.data?.series ?? []);
